import { makeStyles } from '@material-ui/core/styles';

// Shared with PlanScheduleBanner's "cancellation" tone, which must visually match this badge.
export const CANCELLATION_TONE_COLORS = {
    backgroundColor: '#fee2e2',
    color: '#dc2626',
};

export const useStyles = makeStyles((theme) => ({
    pill: {
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: 'nowrap',
    },
    dot: {
        marginRight: 6,
        fontSize: 9,
        lineHeight: 1,
    },
    // Corner-ribbon tones — plan-selection card badges (see Billing/PlanCard).
    current: {
        position: 'absolute',
        top: 24,
        right: -38,
        width: 150,
        transform: 'rotate(45deg)',
        justifyContent: 'center',
        padding: '4px 0',
        borderRadius: 0,
        backgroundColor: '#ECECF5',
        color: theme.palette.grey[600],
        boxShadow: '0 1px 2px rgba(0,0,0,0.15)',
        '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: '100%',
            width: 0,
            height: 0,
            borderStyle: 'solid',
        },
        '&::before': {
            left: 0,
            borderWidth: '4px 4px 0 0',
            borderColor: '#c9c9dd transparent transparent transparent',
        },
        '&::after': {
            right: 0,
            borderWidth: '4px 0 0 4px',
            borderColor: '#c9c9dd transparent transparent transparent',
        },
    },
    popular: ({ accentColor }) => ({
        borderRadius: 12,
        padding: '2px 12px',
        backgroundColor: accentColor || theme.palette.primary.main,
        color: '#ffffff',
    }),
    // Inline status-badge tones — current-plan summary header (see Billing/PlanSummaryHeader).
    active: {
        borderRadius: 9999,
        padding: '2px 10px',
        backgroundColor: '#d1fae5',
        color: '#00D456',
    },
    tier: {
        borderRadius: 9999,
        padding: '2px 10px',
        backgroundColor: '#eef2ff',
        color: theme.palette.primary.main,
        textTransform: 'uppercase',
    },
    cancellationPending: {
        borderRadius: 9999,
        padding: '2px 10px',
        ...CANCELLATION_TONE_COLORS,
    },
}));
